import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetSurveyViewFilterOptionsRPC } from "./getSurveyViewFilterOptionsRPC";

export class GetSurveyViewFilterOptionsRPCClientImpl extends GetSurveyViewFilterOptionsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetSurveyViewFilterOptionsRPC.Request): Promise<LeoRPCResult<GetSurveyViewFilterOptionsRPC.Response, GetSurveyViewFilterOptionsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey-dashboard/GetSurveyViewFilterOptions",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetSurveyViewFilterOptionsRPC.ResponseDTO,
      GetSurveyViewFilterOptionsRPC.Errors.ErrorsDTO,
      GetSurveyViewFilterOptionsRPC.Response,
      GetSurveyViewFilterOptionsRPC.Errors.Errors
    >(
      response,
      "survey-dashboard/GetSurveyViewFilterOptions",
      GetSurveyViewFilterOptionsRPC.Response.fromDTO,
      GetSurveyViewFilterOptionsRPC.Errors.fromDTO
    );
  }
}
